import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import SimpleHeader from "../components/SimpleHeader";

const TermsOfService = () => {
  return (
    <>
      <SimpleHeader />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="body1" paragraph>
          This document outlines the Terms of Service for FarmApp (“App”), a
          digital application developed and operated by ASQI Investment Managers
          Private Limited (“Company” or “we” or “us”) for farmers, Farmer
          Producer Organizations (FPOs), and other agri-business entities
          (“Users” or “you”). By accessing, downloading, or using the App and
          its Services, you agree to abide by these terms. If you do not agree
          to these terms, you are advised not to use the App.
        </Typography>
        <Typography variant="body1" paragraph>
          The Company reserves the right to modify these Terms of Service at any
          time. Continued use of the App after any changes signifies your
          acceptance of the updated terms.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          User Eligibility
        </Typography>
        <Typography variant="body1" paragraph>
          The App is intended for use by individuals and organizations engaged
          in agriculture and related activities who are legally competent to
          enter into binding agreements as per applicable law. If you are not
          eligible, you are prohibited from accessing the App.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Scope of Services
        </Typography>
        <Typography variant="body1" paragraph>
          The App provides access to services like:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Soil testing insights powered by IoT solutions." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Crop detection and advisory using AI technology." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Blockchain-powered traceability for supply chain transparency." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Satellite data for irrigation planning, crop growth, and other activities." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Access to partnerships and collaborations for sustainable farming practices." />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Privacy and Data Protection
        </Typography>
        <Typography variant="body1" paragraph>
          You are responsible for ensuring that any personal or organizational
          data shared via the App has been provided with appropriate consent.
          The Company’s use of such data will adhere to our Privacy Policy.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Intellectual Property
        </Typography>
        <Typography variant="body1" paragraph>
          All intellectual property rights, including trademarks, logos,
          software, content, and design elements within the App, belong to the
          Company or its partners. You are granted a limited, non-transferable
          license to use the App solely for its intended purposes. You are
          prohibited from:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Modifying, reverse-engineering, or decompiling the App." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Republishing, redistributing, or commercially exploiting any content or data obtained from the App without prior authorization." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Using automated tools like bots or crawlers to access the App." />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Restrictions
        </Typography>
        <Typography variant="body1" paragraph>
          Users must refrain from:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Uploading harmful or malicious content, such as viruses or unauthorized scripts." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Using the App for activities that are illegal, defamatory, or harmful to public order." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Misrepresenting identity or impersonating others while using the App." />
          </ListItem>
        </List>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Termination and Violations
        </Typography>
        <Typography variant="body1" paragraph>
          The Company reserves the right to suspend or terminate access to the
          App for any user found violating these terms. Violations may also lead
          to legal action.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Disclaimers and Liability
        </Typography>
        <Typography variant="body1" paragraph>
          The App and its services are provided “as is” without warranties of
          any kind. While the Company strives to ensure accuracy and
          availability, we disclaim liability for errors, omissions,
          interruptions, or delays in service.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Governing Law and Disputes
        </Typography>
        <Typography variant="body1" paragraph>
          These terms shall be governed by the laws of the Republic of India,
          and any disputes will be subject to the exclusive jurisdiction of
          courts in Mumbai, Maharashtra, India.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h5" gutterBottom>
          Grievance Redressal
        </Typography>
        <Typography variant="body1" paragraph>
          For complaints or issues related to the App, you may contact:
        </Typography>
        <Box sx={{ pl: 2 }}>
          <Typography variant="body1">Ms. Sonia Kapoor</Typography>
          <Typography variant="body1">
            Company Name: ASQI Investment Managers Private Limited
          </Typography>
          <Typography variant="body1">
            Address: H-532, Kanakia Zillion, BKC Annexe, Kurla West, Mumbai
            400070
          </Typography>
          <Typography variant="body1">Email: connect@asqi.in</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body1" paragraph>
          The App has been designed to empower farmers and agricultural
          stakeholders to enhance productivity, sustainability, and
          transparency. We request all users to use the App responsibly and in
          compliance with applicable laws.
        </Typography>
      </Container>
    </>
  );
};

export default TermsOfService;
